import metrics, { urlToKey } from 'metrics';
import { log } from 'logger';
import superagentTiming from 'superagent-timing';

const createMetricsHandler = requestPath => {
  const requestPathTag = requestPath ? () => requestPath : urlToKey;

  return data => {
    const { request: { url, method }, duration, response: { statusCode = 0 } } = data;
    const prefix = `${requestPathTag(url)}`.toLowerCase();
    metrics.timing('api', duration, [`request-path:${prefix}`, `http-method:${method}`, `status-code:${statusCode}`]);
  };
};

const createErrorHandler = metricsHandler => {
  return (error, message, data) => {
    metricsHandler(data);
    log.error(error, message);
  };
};

export default requestPath => {
  const metricsHandler = createMetricsHandler(requestPath);

  return superagentTiming(metricsHandler, createErrorHandler(metricsHandler));
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/request-metrics/index.js
 **/